import "./index.scss"

interface IProps {
  color: string;
  onClickHandle?: () => void;
}

export const BackIcon = ({ color, onClickHandle }: IProps) => {
  return (
    <div onClick={onClickHandle} className="back-icon-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="43"
        height="43"
        viewBox="0 0 43 43"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.13443 5.20192C0.11838 7.19533 0.118005 9.80503 0.117252 15.0244L0.115501 27.1398C0.114748 32.3592 0.114377 34.9689 1.12985 36.9626C2.02309 38.7163 3.44859 40.1422 5.20204 41.036C7.19544 42.052 9.80515 42.0524 15.0246 42.0531L27.1399 42.0549C32.3593 42.0556 34.969 42.056 36.9627 41.0405C38.7164 40.1473 40.1423 38.7218 41.0361 36.9684C42.0521 34.975 42.0525 32.3652 42.0533 27.1458L42.055 15.0305C42.0558 9.81108 42.0561 7.20137 41.0407 5.20768C40.1474 3.45397 38.7219 2.02806 36.9685 1.13431C34.9751 0.118263 32.3654 0.117889 27.146 0.117136L15.0306 0.115385C9.81119 0.114632 7.20149 0.114261 5.20779 1.12974C3.45409 2.02298 2.02818 3.44847 1.13443 5.20192ZM25.0634 15.7436C25.9734 14.8338 25.9736 13.3586 25.0638 12.4486C24.1541 11.5386 22.6789 11.5384 21.7689 12.4481L14.7783 19.4368C13.8683 20.3465 13.8681 21.8217 14.7778 22.7317L21.7664 29.7223C22.6762 30.6323 24.1513 30.6326 25.0614 29.7228C25.9714 28.8131 25.9716 27.3379 25.0618 26.4279L19.7204 21.0849L25.0634 15.7436Z"
          fill={color}
        />
      </svg>
    </div>
  );
};
